<template>
  <div class="skuPage">
    <el-table :data="itemInfos" style="width: 100%" border>
      <el-table-column width="487">
        <template slot="header" slot-scope="scope">
          <div class="shopName">
            <img
              v-if="info.shopInfo?.shopLogo && info.shopInfo?.shopLogo != ''"
              :src="info.shopInfo?.shopLogo"
              alt=""
              class="shop-logo"
            />
            <img v-else :src="require('@/assets/img/shop-logo.png')" class="shop-logo" />
            <span @click="linkToStore(info.shopInfo?.shopId)" class="pointer" style="font-size: 14px; font-weight: 700">
              {{ info.shopInfo?.shopName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ info.shopInfo?.merchantEntityName }}
            </span>
            <span @click.stop="onContactCustomerService(info.shopInfo?.storeId)" class="pointer store__title__contact">
              <img :src="require('@/assets/img/service-icon.png')" alt="" />
              联系商家
            </span>
          </div>
        </template>

        <template slot-scope="scope">
          <div class="shop">
            <img :src="scope.row?.itemThumbnail" alt="" v-if="scope.row?.itemThumbnail" />
            <img v-else :src="require('@/assets/img/goods-empty.png')" />
            <div class="desc">
              <div class="title">{{ scope.row?.itemName }}</div>
              <div class="spec">{{ scope.row?.spec }}</div>
              <div class="realPrice">
                售价：
                <span>￥{{ scope.row?.realPriceYuan }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="实付单价" width="175">
        <template #default="{ row }">
          <span>￥{{ row.unitPriceYuan }}</span>
        </template>
      </el-table-column>
      <el-table-column label="购买数量">
        <template #default="{ row }">
          <span>{{ row.number }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请退款数量">
        <template #default="{ row }">
          <span>{{ row.refundNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请退款金额">
        <template #default="{ row }">
          <span>￥{{ row.refundPayAmountYuan }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="extend">
      <div class="name">{{ customerName }}</div>
      <div class="return-receive">
        <div class="returnType">{{ returnType }}</div>
        <el-button class="btn-receive" type="primary" v-if="info.refundShowStatus == 6" @click="onConfirmReceiveRefund(info.refundOrderSn)">确认收款</el-button>
      </div>
    </div>
    <div class="applyRefundAmount">
      <div class="text">
        申请退款总额：
        <span>￥{{ info.applyRefundAmountYuan }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '@/services';
import { mapGetters } from 'vuex';

export default {
  props: ['info'],
  computed: {
    itemInfos() {
      return this.info.itemInfos;
    },
    customerName() {
      return this.info.customerName;
    },
    shopInfo() {
      return this.info.shopInfo;
    },
    returnType() {
      const { returnType } = this.info;
      if (returnType === 0) {
        return '整单退款';
      }
      if (returnType === 2) {
        return '退货退款';
      }
    },
    ...mapGetters({
      groupChat: 'imChatService/getPcGroupChat',
      groupList: 'imChatService/getPcGroupList'
    })
  },
  methods: {
    linkToStore(shopId) {
      this.$router.push({ path: `/store/${shopId}/homePage` });
    },
    // 联系客服
    async onContactCustomerService(storeId) {
      const res = await api.shop.creatSession({
        storeId: storeId
      });
      const { groupId } = res;
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.$store.dispatch('imDialogService/openDialog');
    },
    // 确认收款
    onConfirmReceiveRefund(refundOrderSn) {
      this.$confirm('您确认收到商家的退款凭证并收到该笔款项吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        title: null,
        alignFooter: 'right',
        type: 'warning'
      }).then(async () => {
        const res = await api.refund.confirmReceiveRefund({ refundOrderSn })
        this.$emit('refresh')
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.skuPage {
  //border: 1px solid #dfdfdf;
  ::v-deep .el-table thead {
    background: transparent !important;
  }
  ::v-deep .el-table thead th {
    background: transparent !important;
    border-right: none;
  }
  .shop {
    display: flex;
    img {
      width: 80px;
      height: 80px;
    }
    .desc {
      margin-left: 8px;
      .title {
        font-weight: 500;
        color: #333333;
        line-height: 18px;
        font-size: 12px;
      }
      .spec {
        color: #888888;
        line-height: 18px;
        font-size: 12px;
        margin: 4px 0;
      }
      .realPrice {
        color: #8c8c8c;
        font-size: 12px;
        span {
          color: #262626;
        }
      }
    }
  }
  .extend {
    padding: 20px;
    border: 1px solid #eee;
    border-top: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-weight: 400;
      color: #999999;
      line-height: 12px;
      font-size: 12px;
    }
    .return-receive {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .returnType {
      color: #595959;
      font-size: 12px;
    }
    .btn-receive {
      margin-left: 16px;
    }
  }
  .applyRefundAmount {
    padding: 24px 26px;
    display: flex;
    justify-content: flex-end;
    border: 1px solid #dfdfdf;
    margin-top: 12px;
    .text {
      font-size: 14px;
      color: #333;
      line-height: 19px;
      font-weight: 400;
      span {
        color: #d96900;
        line-height: 24px;
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
  .shopName {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;
    .shop-logo {
      margin-right: 4px;
      width: 24px;
      height: 24px;
    }
    .store__title__contact {
      margin-left: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #1e8dff;
      line-height: 1;
      display: flex;
      align-items: center;
      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }
  }
}
</style>
